




















































































import { Vue, Component, Watch } from "vue-property-decorator";
import CField from "@/components/form/CField.vue";
import { LearningRequestsListParamsV2 } from "@/getinfo-api/learningRequestsV2";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { ContractorsListClass } from "@/classes/list/ContractorsListClass";
import { getCurrentCompanyId } from "@/plugins/roles";
import { EmployeesListClass } from "@/classes/list/EmployeesListClass";
import { CoursesListClass } from "@/classes/list/CoursesListV2Class";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({ components: { CustomButton, CSingleSelect, CField } })
export default class LearningRequestFilter extends Vue {
  params: LearningRequestsListParamsV2 = {
    ids: [],
    courseIds: [],
    companyId: this.selectedCompanyId
  };
  contractorList: ContractorsListClass = new ContractorsListClass({
    companyId: this.selectedCompanyId
  });
  employeeList: EmployeesListClass = new EmployeesListClass({
    id: this.selectedCompanyId
  });
  coursesList: CoursesListClass = new CoursesListClass({
    companyId: this.selectedCompanyId,
    sort: "createdAt",
    order: "DESC"
  });
  course: any = {};

  clearParams() {
    this.params = {
      ids: [],
      courseIds: [],
      companyId: this.selectedCompanyId
    };
  }

  @Watch("params.contractorType")
  loadType() {
    this.checkClientType();
  }

  @Watch("course")
  checkCourse() {
    if (this.course) {
      this.params.courseIds = [this.course.id];
    } else {
      this.params.courseIds = [];
    }
    this.checkParams();
  }

  @Watch("params", { deep: true })
  checkParams() {
    this.$emit("input", this.params);
  }

  checkClientType() {
    //@ts-ignore
    this.contractorList.params.type = !this.params.contractorType
      ? undefined
      : this.params.contractorType;
    this.contractorList.params.offset = 0;
    this.contractorList.listItems = [];
    this.contractorList.list();
  }

  get selectedCompanyId() {
    return getCurrentCompanyId();
  }
}
